<template>
  <div class="p-0" style="width: 100%; height: 100%; display: flex; flex-direction: column; min-height: 0px;">

    <v-card class="rounded-lg mb-2 pa-2" elevation="1">
      <v-row align="start" justify="space-between">

        <v-col cols="12" md="8" class="d-flex align-center">
          <v-avatar color="deep-purple lighten-4" size="60" class="mr-6">
            <span class="deep-purple--text text--darken-2 text-h5 font-weight-bold">{{displayNameAbreviation}}</span>
          </v-avatar>

          <div>
            <h1 class="text-h5 font-weight-medium mb-1">{{displayMita + ' - Jahresübersicht ' + date.split('-')[0]}}</h1>
            <div class="subtitle-1 grey--text text--darken-1 mb-3 d-flex align-center">
              <v-chip class="mr-2" color="grey lighten-4" text-color="grey darken-3" label>
                <v-icon left small>mdi-domain</v-icon>
                Kostenstelle: &nbsp;<b>{{' ' + displayKost}}</b>
              </v-chip>
              <v-chip class="mr-2" color="grey lighten-4" text-color="grey darken-3" label>
                <v-icon left small>mdi-account-multiple</v-icon>
                Mitarbeitergruppe: &nbsp;<b>{{' ' + displayMigr}}</b>
              </v-chip>
              <v-chip class="mr-2" color="grey lighten-4" text-color="grey darken-3" label>
                <v-icon left small>mdi-calendar-range</v-icon>
                Eintrittsdatum: &nbsp;<b>{{' ' + displayEntryDate}}</b>
              </v-chip>
            </div>

            <!--div class="d-flex flex-wrap" style="gap: 8px">
            </div-->
          </div>
        </v-col>

        <v-col cols="12" md="4" class="d-flex justify-md-end">
          <v-sheet
              color="deep-purple lighten-5"
              class="rounded-lg pa-4"
              width="100%"
              max-width="300"
          >
            <div class="d-flex justify-space-between mb-2 text-body-2">
              <span>VP-Intern</span>
              <span class="font-weight-bold">{{displayVpIntern}}</span>
            </div>
            <div class="d-flex justify-space-between text-body-2">
              <span>VP-Extern</span>
              <span class="font-weight-bold">{{displayVpExtern}}</span>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </v-card>

    <v-row class="mb-2" style="height: 320px; flex: 0">

      <v-col cols="12" md="4">
        <v-card class="rounded-lg fill-height pa-2" elevation="1">
          <v-card-title class="text-body-1 font-weight-medium pb-2">
            <v-icon color="primary" class="mr-2">mdi-beach</v-icon>
            Urlaub
            <v-btn
                elevation="2"
                x-small
                class="ml-auto"
                style="margin-right: 8px"
                @click="queryDetails('holiday')"
            >Details</v-btn>
            <v-icon small color="green darken-2"
                    @click="newHolGranted = (holGranted+'').replace('.', ',');
                            newHolPrevYear = (holPrevYear+'').replace('.', ',');
                            showHolliday = true">mdi-pencil</v-icon>
          </v-card-title>

          <v-card-text class="d-flex align-center mt-2">
            <div class="mr-6 text-center">
              <v-progress-circular
                  :rotate="-90"
                  :size="100"
                  :width="10"
                  :value="(holSaldo/(holGranted + holPrevYear))*100"
                  :color="'green darken-2'"
                  :background-color=" holSaldo >= 0 ? 'grey lighten-3' : 'error'"
              >
                <div class="d-flex flex-column align-center">
                  <span class="text-h5 font-weight-bold" :class="{
                    'green--text': holSaldo >= 0,
                    'text--darken-2': holSaldo >= 0,
                    'error--text': holSaldo < 0
                  }">{{displayNumber(holSaldo, '')}}</span>
                  <span class="caption text-uppercase grey--text">Saldo</span>
                </div>
              </v-progress-circular>
            </div>

            <div style="width: 100%">
              <div class="d-flex justify-space-between mb-2 text-body-2">
                <span class="grey--text text--darken-1">Vortrag Vorjahr</span>
                <span  class="font-weight-bold">{{displayNumber(holPrevYear, 'Tage')}}</span>
              </div>
              <v-divider class="mb-2"></v-divider>
              <div class="d-flex justify-space-between mb-2 text-body-2">
                <span class="grey--text text--darken-1">Anspruch laufend</span>
                <span  class="font-weight-bold">{{displayNumber(holGranted, 'Tage')}}</span>
              </div>
              <v-divider class="mb-2"></v-divider>
              <div class="d-flex justify-space-between text-body-2">
                <span class="grey--text text--darken-1">verbraucht</span>
                <span class="font-weight-bold">{{displayNumber(holUsed, 'Tage')}}</span>
              </div>
              <v-divider class="mb-2 border-dark"></v-divider>
              <div class="d-flex justify-space-between text-body-2">
                <span class="black--text font-weight-bold text--darken-1">Saldo</span>
                <span class="font-weight-bold" :class="{
                    'green--text': holSaldo >= 0,
                    'text--darken-2': holSaldo >= 0,
                    'error--text': holSaldo < 0
                  }">{{displayNumber(holSaldo, 'Tage')}}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="rounded-lg fill-height pa-2" elevation="1">
          <v-card-title class="text-body-1 font-weight-medium pb-2">
            <v-icon color="amber darken-2" class="mr-2">mdi-clock-time-four-outline</v-icon>
            Überstunden
            <v-btn
                elevation="2"
                x-small
                class="ml-auto"
                style="margin-right: 8px"
                @click="queryDetails('ueb')"
            >Details</v-btn>
            <v-icon small color="green darken-2"
                    @click="newUebPrevYear = (ueb_prev_year+'').replace('.', ',');
                            showUeb = true">mdi-pencil</v-icon>
          </v-card-title>
          <v-card-text class="d-flex align-center mt-2">
            <div class="mr-6 text-center">
              <v-progress-circular
                  :rotate="-90"
                  :size="100"
                  :width="10"
                  :value="(ueb_saldo/(ueb_performed + ueb_prev_year))*100"
                  :color="'green darken-2'"
                  :background-color=" ueb_saldo >= 0 ? 'grey lighten-3' : 'error lighten-1'"
              >
                <div class="d-flex flex-column align-center">
                  <span class="text-h5 font-weight-bold" :class="{
                    'green--text': ueb_saldo >= 0,
                    'text--darken-2': ueb_saldo >= 0,
                    'error--text': ueb_saldo < 0
                  }">{{displayFloat(ueb_saldo)}}</span>
                  <span class="caption text-uppercase grey--text">Saldo</span>
                </div>
              </v-progress-circular>
            </div>

            <div style="width: 100%">
              <div class="d-flex justify-space-between mb-2 text-body-2">
                <span class="grey--text text--darken-1">Vortrag Vorjahr</span>
                <span  class="font-weight-bold">{{displayFloat(ueb_prev_year, 'Stunden')}}</span>
              </div>
              <v-divider class="mb-2"></v-divider>
              <div class="d-flex justify-space-between mb-2 text-body-2">
                <span class="grey--text text--darken-1">aufgebaut</span>
                <span  class="font-weight-bold">{{displayFloat(ueb_performed, 'Stunden')}}</span>
              </div>
              <v-divider class="mb-2"></v-divider>
              <div class="d-flex justify-space-between text-body-2">
                <span class="grey--text text--darken-1">abgebaut</span>
                <span class="font-weight-bold">{{displayFloat(ueb_used, 'Stunden')}}</span>
              </div>
              <v-divider class="mb-2 border-dark"></v-divider>
              <div class="d-flex justify-space-between text-body-2">
                <span class="black--text font-weight-bold text--darken-1">Saldo</span>
                <span class="font-weight-bold" :class="{
                    'green--text': ueb_saldo >= 0,
                    'text--darken-2': ueb_saldo >= 0,
                    'error--text': ueb_saldo < 0
                  }">{{displayFloat(ueb_saldo, 'Stunden')}}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="rounded-lg fill-height pa-2" elevation="1">
          <v-card-title class="text-body-1 font-weight-medium pb-2">
            <v-icon color="error" class="mr-2">mdi-timeline-clock</v-icon>
            Sonstige Zeiten
            <v-icon small color="green darken-2" class="ml-auto"
                    @click="changeOthers = JSON.parse(JSON.stringify(others_settings)); showChangeOthers = true;">mdi-wrench</v-icon>
          </v-card-title>

          <v-card-text class="pt-4">
            <div>
              <div class="d-flex justify-space-between text-body-2">
                <span>Krankheitstage</span>
                <strong>{{displayNumber(others_values.sickdays, 'Tage')}}</strong>
              </div>
              <v-divider class="mb-2"></v-divider>
              <div class="d-flex justify-space-between text-body-2">
                <span>Befreiung</span>
                <strong>{{displayNumber(others_values.exemptions, 'Tage')}}</strong>
              </div>
              <v-divider class="mb-2"></v-divider>
              <div class="d-flex justify-space-between text-body-2">
                <span>Fehlstunden</span>
                <strong>{{displayFloat(others_values.absences, 'Stunden')}}</strong>
              </div>
              <v-divider class="mb-2"></v-divider>
              <div class="d-flex justify-space-between text-body-2">
                <span>Fernbleiben</span>
                <strong>{{displayNumber(others_values.leaves, 'Tage')}}</strong>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="rounded-lg" elevation="1" style="height: 100%; max-height: 100%">
      <v-card-title class="text-subtitle-1 font-weight-bold px-6 pt-5">
        Übersicht sonstige
        <v-icon small color="green darken-2" class="ml-auto"
                @click="changeTable = JSON.parse(JSON.stringify(table_settings)); showChangeTable = true;">mdi-wrench</v-icon>
      </v-card-title>

      <v-simple-table class="px-2 pb-2"
                      fixed-header>
        <template v-slot:default>
          <thead>
          <tr style="background: lightgrey; border: 2px solid rgba(0,0,0,0.42)">
            <th class="text-left font-weight-medium pl-6 font-weight-bold black--text" style="white-space: nowrap; min-width: 180px; background: rgba(241,241,241,0.95); color: black !important; border-left: thin solid rgba(0, 0, 0, 0.12)">Typ</th>
            <th class="text-center font-weight-medium pl-6 font-weight-bold black--text" style="background: rgba(241,241,241,0.95); color: black !important; border-left: thin solid rgba(0, 0, 0, 0.12)">⌀</th>
            <th v-for="(month, i) in months" :key="month" class="text-center caption text-uppercase font-weight-bold black--text pointer" @click="$emit('change-to-month', i+1)" style="background: rgba(241,241,241,0.95); color: black !important; border-left: thin solid rgba(0, 0, 0, 0.12)">
              {{ month }}
            </th>
            <th class="text-center font-weight-bold black--text font-weight-bold" style="background: rgba(241,241,241,0.95); color: black !important; border-left: thin solid rgba(0, 0, 0, 0.12); border-left: thin solid rgba(0, 0, 0, 0.12)">Summe</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in tableData" :key="i" class="hover-row" :class="{'table-divider': i === 2, 'table-divider-l': i <= 2 }" >
            <td class="font-weight-medium pl-6" style="border-left: thin solid rgba(0, 0, 0, 0.12); white-space: nowrap;">{{ truncateString(item.name) }}</td>
            <td class="font-weight-medium pl-6" style="border-left: thin solid rgba(0, 0, 0, 0.12)">{{ getLohnUnit(item.access, item.type) }}</td>
            <td v-for="(val, index) in item.values" :key="index" class="text-right">
              <span v-if="val === 0" class="grey--text text--lighten-2">—</span>
              <span v-else :class="{
                    'green--text': val >= 0 && i === 2,
                    'text--darken-2': val >= 0 && i === 2,
                    'error--text': val < 0 && i === 2,
                    'font-weight-medium': i === 2,
                  }" class="pointer" @click="queryYearlyDetails(index+1, item.access, i < 3 ? 'soll' : item.type, i < 3 ? 'Arbeitszeitsaldo' : item.name)" >{{ (val.toFixed(2)+ '').replace('.', ',') }}</span>
            </td>
            <td class="text-right font-weight-bold" style="" :class="{
                    'green--text': sumArray(item.values) >= 0 && i === 2,
                    'text--darken-2': sumArray(item.values) >= 0 && i === 2,
                    'error--text': sumArray(item.values) < 0 && i === 2
                  }">{{ (sumArray(item.values).toFixed(2)+ '').replace('.', ',') }}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    <v-dialog
        v-model="showHolliday"
        :max-width="'300px'"
        persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Urlaubsbuchung</span>
        </v-card-title>
        <v-card-text style="padding: 12px 28px 20px;">
          <v-text-field
              label="Urlaubsvortrag"
              v-model="newHolPrevYear"
              suffix="Tage"
          ></v-text-field>
          <v-text-field
              label="Urlaubsanspruch"
              v-model="newHolGranted"
              suffix="Tage"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showHolliday = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              :disabled="
              !newHolPrevYear.replace(/[^0-9,-.]/g, '').replace(',','.')
              || parseFloat(newHolPrevYear.replace(/[^0-9,-.]/g, '').replace(',','.')) < 0
              || !newHolGranted.replace(/[^0-9,-.]/g, '').replace(',','.')
              || parseFloat(newHolGranted.replace(/[^0-9,-.]/g, '').replace(',','.')) < 0"
              v-on:click.stop="changeSaldo(parseFloat(newHolPrevYear.replace(/[^0-9,-.]/g, '').replace(',','.')), parseFloat(newHolGranted.replace(/[^0-9,-.]/g, '').replace(',','.')), -1)"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showUeb"
        :max-width="'300px'"
        persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Überstundenbuchung</span>
        </v-card-title>
        <v-card-text style="padding: 12px 28px 20px;">
          <v-text-field
              label="Überstundenvortrag"
              v-model="newUebPrevYear"
              suffix="Tage"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showUeb = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              :disabled="
              !newUebPrevYear.replace(/[^0-9,-.]/g, '').replace(',','.')
              || parseFloat(newUebPrevYear.replace(/[^0-9,-.]/g, '').replace(',','.')) < 0"
              v-on:click.stop="changeSaldo(-1, -1, parseFloat(newUebPrevYear.replace(/[^0-9,-.]/g, '').replace(',','.')))"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showChangeOthers"
        :max-width="'450px'"
        persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Einstellung: Sonstige Zeiten</span>
        </v-card-title>
        <v-card-text style="padding: 12px 28px 20px;">
          <v-autocomplete
              v-model="changeOthers.sickdays"
              :items="pe05Fehls"
              chips
              deletable-chips
              label="Krankheitstage"
              multiple
              item-text="name"
              item-value="bis_id"
          ></v-autocomplete>
          <v-autocomplete
              v-model="changeOthers.exemptions"
              :items="pe05Fehls"
              chips
              deletable-chips
              label="Befreiung"
              multiple
              item-text="name"
              item-value="bis_id"
          ></v-autocomplete>
          <v-autocomplete
              v-model="changeOthers.absences"
              :items="pe02Fehls"
              chips
              deletable-chips
              label="Fehlstunden"
              multiple
              item-text="name"
              item-value="bis_id"
          ></v-autocomplete>
          <v-autocomplete
              v-model="changeOthers.leaves"
              :items="pe05Fehls"
              chips
              deletable-chips
              label="Fernbleiben"
              multiple
              item-text="name"
              item-value="bis_id"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showChangeOthers = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="others_settings = changeOthers; showChangeOthers = false; saveSettings()"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showChangeTable"
        :max-width="'450px'"
        persistent
        scrollable
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Einstellung: Übersicht sonstige</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 50vh">
          <v-list>
            <v-list-item-group
                v-model="changeTable"
                multiple
            >
              <template v-for="(item, i) in possibleSettings">
                <v-divider
                    v-if="!item"
                    :key="`divider-${i}`"
                ></v-divider>

                <v-list-item
                    v-else
                    :key="`item-${i}`"
                    :value="item"
                    active-class="primary--text text--accent-4"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-content>
                      <v-list-item-title v-text="item.name + ' (' + getLohnUnit(item.access, item.type) + ')'"></v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-checkbox
                          :input-value="active"
                          color="primary accent-4"
                      ></v-checkbox>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showChangeTable = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="table_settings = changeTable; showChangeTable = false; saveSettings()"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showHolidayDetails"
        :max-width="'450px'"
        scrollable
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Details: Urlaub</span>
          <v-col></v-col>
          <v-btn
              icon
              @click="showHolidayDetails = false; showCalendar('holiday')"
          >
            <v-icon>mdi-calendar-month-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 50vh">
          <v-row style="padding: 0 8px !important; margin-bottom: 0px">
            <v-col class="p-0">
              <v-subheader
                  class="font-weight-bold text--darken-2"
                  v-text="'Datum'"
                  style="height: 36px; padding-left: 8px; padding-right: 0px"
              ></v-subheader>
            </v-col>
            <v-col class="p-0">
              <v-subheader
                  class="font-weight-bold text--darken-2 text-center"
                  v-text="'Urlaub verbraucht'"
                  style="height: 36px; padding-left: 36px"
              ></v-subheader>
            </v-col>
          </v-row>
          <v-list three-line>
            <template v-for="(item, index) in holidayOverviews">
              <v-divider
                  v-if="index !== 0"
                  :key="index"
                  style="margin: 4px"
              ></v-divider>
              <v-subheader
                  v-if="index === 0 || holidayOverviews[index-1].month !== item.month"
                  :key="months[item.month]"
                  v-text="months[item.month]"
                  style="height: 36px; padding-left: 8px"
              ></v-subheader>

              <v-list-item
                  :key="item.date"
              >
                <v-list-item-title  class="pointer" @click="queryMitaDay(item.date)" v-html="item.date.split('-').reverse().join('.')"></v-list-item-title>
                <v-list-item-title class="text-center pointer" @click="queryMitaDay(item.date)" v-html="displayNumber(item.amount, 'Tage')"></v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showHolidayDetails = false"
          >
            Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showUebDetails"
        :max-width="'450px'"
        scrollable
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Details: Überstunden</span>
          <v-col></v-col>
          <v-btn
              icon
              @click="showUebDetails = false; showCalendar('ueb')"
          >
            <v-icon>mdi-calendar-month-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 50vh">
          <v-row style="padding: 0 20px !important; margin-bottom: 0px !important; ">
            <v-col class="p-0">
              <v-subheader
                  class="font-weight-bold text--darken-2"
                  v-text="'Datum'"
                  style="height: 36px; padding-left: 8px; padding-right: 0px"
              ></v-subheader>
            </v-col>
            <v-col class="p-0">
              <v-subheader
                  class="font-weight-bold text--darken-2 text-center"
                  v-text="'aufgebaut'"
                  style="height: 36px; padding-left: 36px"
              ></v-subheader>
            </v-col>
            <v-col class="p-0">
              <v-subheader
                  class="font-weight-bold text--darken-2 text-center"
                  v-text="'abgebaut'"
                  style="height: 36px; padding-left: 36px"
              ></v-subheader>
            </v-col>
          </v-row>
          <v-list three-line>
            <template v-for="(item, index) in uebOverviews">
              <v-divider
                  v-if="index !== 0"
                  :key="index"
                  style="margin: 4px"
              ></v-divider>
              <v-subheader
                  v-if="index === 0 || uebOverviews[index-1].month !== item.month"
                  :key="months[item.month]"
                  v-text="months[item.month]"
                  style="height: 36px; padding-left: 8px"
              ></v-subheader>

              <v-list-item
                  :key="item.date"
              >
                <v-list-item-title  class="pointer" @click="queryMitaDay(item.date)" v-html="item.date.split('-').reverse().join('.')"></v-list-item-title>
                <v-list-item-title class="text-center pointer" @click="queryMitaDay(item.date)" v-html="displayFloat(item.sum_pos, 'Std.')"></v-list-item-title>
                <v-list-item-title class="text-center pointer" @click="queryMitaDay(item.date)" v-html="displayFloat(item.sum_neg, 'Std.')"></v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showUebDetails = false"
          >
            Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showYearDetails"
        :max-width="dialogType === 'soll' ? '650px' : '450px'"
        scrollable
    >
      <v-card>
        <v-card-title>
          <v-col  style="padding: 0px; display: flex; flex-direction: column">
            <span style="font-weight: bold; margin-right: 18px" >{{monthDate}}</span>
            <span>{{ dialogName + (dialogType !== 'rb' ? ': ' : ' ') + calculateSaldo}}</span>
          </v-col>
          <v-btn
              icon
              @click="showYearDetails = false; showCalendar(dialogType)"
          >
            <v-icon>mdi-calendar-month-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 50vh">
          <v-row style="padding: 0 20px !important; margin-bottom: 0px !important; ">
            <v-col class="p-0">
              <v-subheader
                  class="font-weight-bold text--darken-2"
                  v-text="'Datum'"
                  style="height: 36px; padding-left: 8px; padding-right: 0px"
              ></v-subheader>
            </v-col>
            <v-col class="p-0" v-if="dialogType === 'soll'">
              <v-subheader
                  class="font-weight-bold text--darken-2 text-center"
                  v-text="'Soll'"
                  style="height: 36px; padding-left: 36px"
              ></v-subheader>
            </v-col>
            <v-col class="p-0" v-if="dialogType === 'soll'">
              <v-subheader
                  class="font-weight-bold text--darken-2 text-center"
                  v-text="'Ist'"
                  style="height: 36px; padding-left: 36px"
              ></v-subheader>
            </v-col>
            <v-col class="p-0" v-if="dialogType === 'soll'">
              <v-subheader
                  class="font-weight-bold text--darken-2 text-center"
                  v-text="'Saldo'"
                  style="height: 36px; padding-left: 36px"
              ></v-subheader>
            </v-col>
            <v-col class="p-0" v-if="dialogType === 'rb'">
              <v-subheader
                  class="font-weight-bold text--darken-2 text-center"
                  v-text="'Von'"
                  style="height: 36px; padding-left: 44px"
              ></v-subheader>
            </v-col>
            <v-col class="p-0" v-if="dialogType === 'rb'">
              <v-subheader
                  class="font-weight-bold text--darken-2 text-center"
                  v-text="'Bis'"
                  style="height: 36px; padding-left: 44px"
              ></v-subheader>
            </v-col>
            <v-col class="p-0" v-if="dialogType !== 'rb' && dialogType !== 'soll'">
              <v-subheader
                  class="font-weight-bold text--darken-2 text-center"
                  v-text="dialogName"
                  style="height: 36px; padding-left: 58px"
              ></v-subheader>
            </v-col>
          </v-row>
          <v-list three-line v-if="dialogType === 'soll'">
            <template v-for="(item, index) in soll">
              <v-divider
                  v-if="index !== 0"
                  :key="index"
                  style="margin: 4px"
              ></v-divider>
              <v-list-item
                  :key="index + 'soll'"
              >
                <v-list-item-title class="pointer" @click="queryMitaDay(dialogDate.split('-')[0] + '-' + dialogDate.split('-')[1] + '-' + (''+(index+1)).padStart(2, '0'))" v-html="(''+(index+1)).padStart(2, '0') + '.' + dialogDate.split('-')[1] + '.' + dialogDate.split('-')[0]"></v-list-item-title>
                <v-list-item-title class="text-center pointer" @click="queryMitaDay(dialogDate.split('-')[0] + '-' + dialogDate.split('-')[1] + '-' + (''+(index+1)).padStart(2, '0'))" v-html="displayFloat(item, 'Std.')"></v-list-item-title>
                <v-list-item-title class="text-center pointer" @click="queryMitaDay(dialogDate.split('-')[0] + '-' + dialogDate.split('-')[1] + '-' + (''+(index+1)).padStart(2, '0'))" v-html="displayFloat(ist[index], 'Std.')"></v-list-item-title>
                <v-list-item-title class="text-center pointer" @click="queryMitaDay(dialogDate.split('-')[0] + '-' + dialogDate.split('-')[1] + '-' + (''+(index+1)).padStart(2, '0'))" :style="{'color': ist[index] - item < 0 ? 'red' : 'green'}" v-html="displayFloat(ist[index] - item, 'Std.')"></v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
          <v-list three-line v-else-if="dialogType === 'rb'">
            <template v-for="(item, index) in rbs">
              <template v-for="(rb, i2) in item" v-if="item">
                <v-divider
                    :key="'rb' + index + '-' + i2"
                    style="margin: 4px"
                ></v-divider>
                <v-list-item
                    :key="index + '-' + i2 + 'rb'"
                >
                  <v-list-item-title class="pointer" @click="queryMitaDay(dialogDate.split('-')[0] + '-' + dialogDate.split('-')[1] + '-' + (''+(index+1)).padStart(2, '0'))" v-html="(''+(index+1)).padStart(2, '0') + '.' + dialogDate.split('-')[1] + '.' + dialogDate.split('-')[0]"></v-list-item-title>
                  <v-list-item-title class="text-center pointer" @click="queryMitaDay(dialogDate.split('-')[0] + '-' + dialogDate.split('-')[1] + '-' + (''+(index+1)).padStart(2, '0'))" v-html="rb.von"></v-list-item-title>
                  <v-list-item-title class="text-center pointer" @click="queryMitaDay(dialogDate.split('-')[0] + '-' + dialogDate.split('-')[1] + '-' + (''+(index+1)).padStart(2, '0'))" v-html="rb.bis"></v-list-item-title>
                </v-list-item>
              </template>
            </template>
          </v-list>
          <v-list three-line v-else>
            <template v-for="(item, index) in floats">
              <v-divider
                  v-if="item > 0"
                  :key="index"
                  style="margin: 4px"
              ></v-divider>
              <v-list-item
                  :key="index + 'floats'"
                  v-if="item > 0"
              >
                <v-list-item-title class="pointer" @click="queryMitaDay(dialogDate.split('-')[0] + '-' + dialogDate.split('-')[1] + '-' + (''+(index+1)).padStart(2, '0'))" v-html="(''+(index+1)).padStart(2, '0') + '.' + dialogDate.split('-')[1] + '.' + dialogDate.split('-')[0]"></v-list-item-title>
                <v-list-item-title class="text-center pointer" v-html="displayFloat(item, dialogUnit)" @click="queryMitaDay(dialogDate.split('-')[0] + '-' + dialogDate.split('-')[1] + '-' + (''+(index+1)).padStart(2, '0'))"></v-list-item-title>
              </v-list-item>
            </template>
          </v-list>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showYearDetails = false"
          >
            Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <calendar-dialog ref="calendarDialog" @event-clicked="queryMitaDay" :date="dialogDate" :lohn-name="dialogName" :unit-name="dialogUnit" :floats="floats" :ist="ist" :soll="soll" :rbs="rbs" :holiday-overviews="holidayOverviews" :ueb-overviews="uebOverviews" @show-list="showList"></calendar-dialog>
    <user-day-overview ref="dayOverview" :date="dayOverviewDate" :overview="dayOverview" @goto-day="$router.push('/zeitkontrolle/zeiterfassung?user='+currentMita+'&date=' + dayOverviewDate)"></user-day-overview>

  </div>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import {get} from "immutable";
import CalendarDialog from "@/views/calendar/CalendarDialog.vue";
import UserDayOverview from "@/views/calendar/UserDayOverview.vue";

export default {
  name: "AuskunftYear",
  components: {
    CalendarDialog,
    UserDayOverview
  },
  props: {
    date: {
      type: String,
      default () {
        return new Date().toISOString().substr(0, 10);
      }
    },
    currentMode: {
      type: String,
      default () {
        return "week";
      }
    },
    currentMita: {
      type: String,
      default: () => undefined
    },
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
    mitasFlat: {
      type: Array,
      default: () => []
    },
    holidayLohn: {
      type: String,
      default: ""
    }
  },
  mounted() {
    if (this.currentMita) {
      this.queryData()
    }
  },
  watch: {
    date: function (newDate) {
      if (this.currentMita) {
        this.queryData()
      } else {
        this.ueb_performed =  0;
        this.ueb_used = 0;
        this.ueb_prev_year = 0;
        this.ueb_saldo = 0;
        this.holGranted = 0;
        this.holUsed = 0;
        this.holPrevYear = 0;
        this.holSaldo = 0;
        this.tableData = [
          {
            access: '',
            type: 'saldo',
            name: 'Soll-Stunden',
            values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          },
          {
            access: '',
            type: 'saldo',
            name: 'Ist-Stunden',
            values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          },
          {
            access: '',
            type: 'saldo',
            name: 'Saldo',
            values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          },
        ];
      }
    },
    currentMita: function (newDate) {
      if (this.currentMita) {
        this.queryData()
      } else {
        this.ueb_performed =  0;
        this.ueb_used = 0;
        this.ueb_prev_year = 0;
        this.ueb_saldo = 0;
        this.holGranted = 0;
        this.holUsed = 0;
        this.holPrevYear = 0;
        this.holSaldo = 0;
        this.tableData = [
          {
            access: '',
            type: 'saldo',
            name: 'Soll-Stunden',
            values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          },
          {
            access: '',
            type: 'saldo',
            name: 'Ist-Stunden',
            values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          },
          {
            access: '',
            type: 'saldo',
            name: 'Saldo',
            values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          },
        ];
      }
    },
  },
  computed: {
    calculateSaldo() {
      switch (this.dialogType) {
        case 'soll':
          if (!this.soll || !this.ist) {
            return '';
          }
          let totalSoll = 0;
          for (let i = 0; i < this.soll.length; i++) {
            totalSoll -= this.soll[i];
            totalSoll += this.ist[i];
          }
          return (totalSoll + '').replace('.', ',') + (totalSoll === 1 ? ' Stunde' : ' Stunden');
        case 'rb':
          return '';
        default:
          if (!this.floats) {
            return '';
          }
          let totalFloat = 0;
          for (let i = 0; i < this.floats.length; i++) {
            totalFloat += this.floats[i];
          }
          return (totalFloat + '').replace('.', ',') + ( ' ' + this.dialogUnit);
      }
    },
    monthDate() {
      // format to month name, Year
      let splits = this.dialogDate.split("-");
      return this.monthsLong[parseInt(splits[1])] + ", " + splits[0]
    },
    displayMita() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? mita.name : "Kein Mitarbeiter ausgewählt";
    },
    displayId() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? mita.bis_id : "000000";
    },
    displayMigr() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? mita.migr : "";
    },
    displayKost() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? mita.kost : "";
    },
    displayEntryDate() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? (mita.start_date ? mita.start_date : 'Nicht gesetzt') : "";
    },
    displayNameAbreviation() {
    let mita = this.getCurrentMita(this.currentMita);
      if (mita && mita.name) {
        let names = mita.name.split(' ');
        if (names.length >= 2) {
          return names[0].charAt(0).toUpperCase() + names[1].charAt(0).toUpperCase();
        } else if (names.length === 1) {
          return names[0].charAt(0).toUpperCase();
        }
      }
      return "";
    },
    displayVpIntern() {
      let mita = this.getCurrentMita(this.currentMita);
      if (!mita) {
        return "";
      }
      let vp = mita.price_int;
      vp = vp.replace('EUR', '').replace('EU', '').replace('.', ',').replace('€', '').replace(',', '.').trim();
      // bring to 2 digits after comma
      vp = parseFloat(vp).toFixed(2);
      return (vp + '').replace('.', ',') + " €";
    },
    displayVpExtern() {
      let mita = this.getCurrentMita(this.currentMita);
      if (!mita) {
        return "";
      }
      let vp = mita.price_ext;
      vp = vp.replace('EUR', '').replace('EU', '').replace('.', ',').replace('€', '').replace(',', '.').trim();
      // bring to 2 digits after comma
      vp = parseFloat(vp).toFixed(2);
      return (vp + '').replace('.', ',') + " €";
    },
    pe02Fehls() {
      return this.possible_lohns.filter(item => item.lohn_type === 'F' && item.lohn_usage_type === 'PE02')
    },
    pe05Fehls() {
      return this.possible_lohns.filter(item => item.lohn_type === 'F' && item.lohn_usage_type === 'PE05')
    },
    possibleSettings() {
      let settings = [];
      for (let i = 0; i < this.possible_lohns.length; i++) {
        let item = this.possible_lohns[i];
        let res = {
          name: item.name,
        }
        switch (item.lohn_type) {
          case 'F':
            if (item.lohn_usage_type === 'PE05' && item.unit === '2') {
              let second = {
                name: item.name,
                type: "fehl_02",
                access: item.bis_id
              };
              settings.push(second);
            }
            res.type = item.lohn_usage_type === 'PE02' ? "fehl_02" : "fehl_05";
            res.access = item.bis_id;
            break;
          case 'ZZ':
            res.type = "zz";
            res.access = item.access;
            break;
          default:
            res.type = "sur";
            res.access = item.access;
            break;
        }
        settings.push(res);
      }
      settings.push({
        name: 'Rufbereitschaften',
        type: 'rb',
        access: 'rb_access'
      })
      settings.push({
        name: 'Urlaub verbraucht',
        type: 'hol_02',
        access: 'hol_access'
      })
      settings.push({
        name: 'Urlaub verbraucht',
        type: 'hol_05',
        access: 'hol_access'
      })
      settings.push({
        name: 'Überstunden geleistet RB',
        type: 'ueb_rb',
        access: 'ueb_rb_access'
      })
      settings.push({
        name: 'Überstunden geleistet',
        type: 'ueb',
        access: 'ueb_access'
      })
      return settings.sort((a, b) => a.name.localeCompare(b.name));
    }
  },
  data: () => ({
    months: ['Jan', 'Feb', 'März', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    monthsLong: ["","Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    tableData: [
      {
        name: 'Soll-Stunden',
        access: '',
        type: 'saldo',
        values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: 'Ist-Stunden',
        access: '',
        type: 'saldo',
        values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: 'Saldo',
        access: '',
        type: 'saldo',
        values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
    ],
    ueb_performed: 0,
    ueb_used: 0,
    ueb_prev_year: 0,
    ueb_saldo: 0,
    holGranted: 0,
    holUsed: 0,
    holPrevYear: 0,
    holSaldo: 0,

    showHolliday: false,
    newHolPrevYear: '0',
    newHolGranted: '0',

    showUeb: false,
    newUebPrevYear: '0',

    possible_lohns: [],
    others_settings: {
      sickdays: [],
      exemptions: [],
      absences: [],
      leaves: [],
    },
    table_settings: [],
    changeTable: [],
    showChangeTable: false,
    changeOthers: {
      sickdays: [],
      exemptions: [],
      absences: [],
      leaves: [],
    },
    others_values: {
      sickdays: 0,
      exemptions: 0,
      absences: 0,
      leaves: 0,
    },
    showChangeOthers: false,

    holidayOverviews: [],
    uebOverviews: [],
    showHolidayDetails: false,
    showUebDetails: false,

    dialogDate: new Date().toISOString().substr(0, 10),
    dialogType: null,
    dialogUnit: null,
    dialogName: null,
    soll: [],
    ist: [],
    floats: [],
    rbs: [],
    showYearDetails: false,


    dayOverviewDate: new Date().toISOString().substr(0, 10),
    dayOverview: {
      user_day: {
        soll: 0.0,
        ist: 0.0,
        valence: 0.0,
        has_rufbereitschaft: false,
      },
      time_blocks: [],
      time_surcharges: 0.0,
      ueb_performed: 0.0,
      roundings: 0.0,
      rounding_entries: [],
      rb: "",
      surcharges: [],
    },
  }),
  methods: {
    queryMitaDay(date) {
      this.showUebDetails = false;
      this.showHolidayDetails = false;
      this.showYearDetails = false;
      this.dayOverviewDate = date;
      let mita = this.getCurrentMita(this.currentMita);
      this.showLoader();
      this.$http.get(
          Server_URL_ZK + '/zk/user_day/' + mita.bis_id + "?date=" + this.dayOverviewDate
      ).then(this.responseOkGetDayOverview, this.responseError)
    },
    responseOkGetDayOverview(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.dayOverview = response.body;
        this.$refs.dayOverview.openDialog();
      } else {
        window.location = Redirect_500;
      }
    },
    queryYearlyDetails(month, access, dialogType, lohnName = '') {
      this.showLoader();
      let mita = this.getCurrentMita(this.currentMita);
      this.dialogDate = this.date.split("-")[0] + "-" + ("" + month).padStart(2, "0") + "-01";
      this.dialogUnit = this.getLohnUnit(access, dialogType);
      this.dialogType = dialogType;
      this.dialogName = lohnName;
      console.log(this.dialogDate, this.dialogUnit, this.dialogType);
      this.$http.get(
          Server_URL_ZK + '/zk/overview_year_detail/' + mita.bis_id + "?year=" + this.date.split('-')[0] + "&month=" + month + "&access=" + access + "&lohn_type=" + dialogType
      ).then(this.responseOkYearlyDetails, this.responseError)
    },
    queryDetails(detail_type) {
      this.showLoader();
      let mita = this.getCurrentMita(this.currentMita);
      if (detail_type === 'holiday') {
        this.$http.get(
            Server_URL_ZK + '/zk/overview_detail/holiday/' + mita.bis_id + "?year=" + this.date.split('-')[0]
        ).then(this.responseHolidayDetails, this.responseError)
      } else {
        this.$http.get(
            Server_URL_ZK + '/zk/overview_detail/ueb/' + mita.bis_id + "?year=" + this.date.split('-')[0]
        ).then(this.responseOkUebDetails, this.responseError)
      }
    },
    showList(mode) {
      if(mode === 'holiday') {
        this.showHolidayDetails = true;
      } else if (mode === 'ueb') {
        this.showUebDetails = true;
      } else {
        this.showYearDetails = true;
      }
    },
    showCalendar(mode) {
      if(mode === 'holiday') {
        this.dialogDate = this.date;
        this.$refs.calendarDialog.openDialog('holiday');
      } else if (mode === 'ueb') {
        this.dialogDate = this.date;
        this.$refs.calendarDialog.openDialog('ueb');
      } else {
        this.$refs.calendarDialog.openDialog(this.dialogType);
      }
    },
    responseHolidayDetails(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.dialogDate = this.date;
        this.holidayOverviews = response.body;
        this.$refs.calendarDialog.openDialog('holiday');
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkUebDetails(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.dialogDate = this.date;
        this.uebOverviews = response.body;
        this.$refs.calendarDialog.openDialog('ueb');
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkYearlyDetails(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.soll = response.body.soll;
        this.ist = response.body.ist;
        this.rbs = response.body.rbs;
        this.floats = response.body.floats;
        this.$nextTick(() => {
          this.$refs.calendarDialog.openDialog(this.dialogType);
        });
      } else {
        window.location = Redirect_500;
      }
    },
    get,
    truncateString(str) {
      let maxLength = 35;
      if (str.length > maxLength) {
        return str.slice(0, maxLength - 3) + '...';
      }
      return str;
    },
    getLohnUnit(access, type) {
      switch (type) {
        case 'fehl_02':
        case 'zz':
        case 'ueb':
        case 'ueb_rb':
        case 'hol_02':
        case 'rb':
        case 'saldo':
          return 'Std.';
        case 'fehl_05':
        case 'hol_05':
          return 'Tage';
        case 'sur':
          let lohn = this.possible_lohns.find(item => item.access === access);
          if (lohn) {
            if (lohn.lohn_usage_type === 'PE02') {
              return 'Std.';
            } else if (lohn.lohn_usage_type === 'PE05' && lohn.unit === '2') {
              return 'Tage';
            } else {
              return 'Stk.';
            }
          } else {
            return 'Std.';
          }
      }
    },
    saveSettings() {
      this.showLoader();
      let req = {
        others_setting: this.others_settings,
        table_settings: this.table_settings.sort((a, b) => a.name.localeCompare(b.name))
      }
      this.$http.post(
          Server_URL_ZK + '/zk/overview_year_setting', req
      ).then((reponse) => {
        let mita = this.getCurrentMita(this.currentMita);
        this.$http.get(
            Server_URL_ZK + '/zk/overview_year/' + mita.bis_id + "?year=" + this.date.split('-')[0]
        ).then(this.responseOkGetOverview, this.responseError)
      }, this.responseError);
    },
    changeSaldo(holPrevYear, holGranted, uebPrevYear) {
      let req = {
        hol_prev_year: holPrevYear,
        hol_entitled: holGranted,
        ueb_prev_year: uebPrevYear
      }
      this.showHolliday = false;
      this.showUeb = false;
      this.showLoader();
      let mita = this.getCurrentMita(this.currentMita);
      this.$http.post(
          Server_URL_ZK + '/zk/overview_year/' + mita.bis_id + "?year=" + this.date.split('-')[0], req
      ).then(this.responseOkTrap, this.responseError);
      if (holPrevYear >= 0) {
        this.holPrevYear = holPrevYear;
      }
      if (holGranted >= 0) {
        this.holGranted = holGranted;
      }
      if (uebPrevYear >= 0) {
        this.ueb_prev_year = uebPrevYear;
      }
      // recalc saldo
      this.holSaldo = this.holPrevYear + this.holGranted - this.holUsed;
      this.ueb_saldo = this.ueb_prev_year + this.ueb_performed - this.ueb_used;
    },
    getCurrentMita(id) {
      for (let i = 0; i < this.mitasFlat.length; i++) {
        if (this.mitasFlat[i].id === id) {
          return this.mitasFlat[i];
        }
      }
      return null;
    },
    queryData(){
      let mita = this.getCurrentMita(this.currentMita);
      this.showLoader();
      this.$http.get(
          Server_URL_ZK + '/zk/overview_year/' + mita.bis_id + "?year=" + this.date.split('-')[0]
      ).then(this.responseOkGetOverview, this.responseError)
    },
    responseOkGetOverview(response) {
      this.hideLoader();
      if (response.status === 200) {
        let data = response.body;
        this.ueb_performed = data.ueb_performed;
        this.ueb_used = data.ueb_used;
        this.ueb_prev_year = data.ueb_prev_year;
        this.ueb_saldo = data.ueb_saldo;
        this.holGranted = data.holGranted;
        this.holUsed = data.holUsed;
        this.holPrevYear = data.holPrevYear;
        this.holSaldo = data.holSaldo;
        this.possible_lohns = data.possible_lohns;
        this.others_settings = data.others_settings;
        this.others_values = data.others_values;
        this.table_settings = data.table_settings;
        this.tableData[0].values = data.soll;
        this.tableData[1].values = data.ist;
        this.tableData[2].values = data.saldo;
        for (let i = 0; i < this.table_settings.length; i++) {
          this.tableData[3+i] = {
            name: this.table_settings[i].name,
            access: this.table_settings[i].access,
            type: this.table_settings[i].type,
            values: data.table_times[i] ? data.table_times[i] : [0,0,0,0,0,0,0,0,0,0,0,0]
          }
        }
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkTrap(response) {
      this.hideLoader();
      if (response.status === 200) {
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    displayNumber(num, unit) {
      return (num + '').replace('.', ',') + ' ' + unit;
    },
    displayFloat(num, unit = '') {
      num = parseFloat(num).toFixed(2);
      return (num + '').replace('.', ',') + ' ' + unit;
    },
    sumArray(arr) {
      return arr.reduce((a, b) => a + b, 0);
    }
  }

}
</script>

<style scoped>
/* Custom styling to ensure the table looks clean */
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 0.75rem !important;
  color: #757575 !important;
}

/* Light hover effect */
.hover-row:hover {
  background-color: #f5f5f5 !important;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  height: 32px !important;
}

.table-divider {
  border-bottom: solid 2px #7c7c7c !important;
  border-top: solid 2px #7c7c7c !important;
}

.table-divider-l {
  border-left: solid 2px #7c7c7c !important;
  border-right: solid 2px #7c7c7c !important;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:not(.v-data-table__mobile-row) {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}


::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:not(.v-data-table__mobile-row) {
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.pointer {
  cursor: pointer;
}

.pointer:hover {
  text-decoration: underline;
  text-decoration-style: solid;
}

</style>
